import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraInput } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
/** Removing a member always records why; confirm stays disabled until a reason is typed. */ export function RemoveMemberForm({ pending, onConfirm, onCancel }) {
    const [reason, setReason] = useState('');
    const trimmed = reason.trim();
    return /*#__PURE__*/ _jsxs("form", {
        className: "space-y-2",
        onSubmit: (e)=>{
            e.preventDefault();
            if (trimmed && !pending) onConfirm(trimmed);
        },
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-muted-foreground",
                children: "Remove this Landscape relationship only. The underlying Opportunity, Pursuits, Responses and Proposals remain unchanged."
            }),
            /*#__PURE__*/ _jsx(SpecraInput, {
                autoFocus: true,
                value: reason,
                onChange: (e)=>setReason(e.target.value),
                placeholder: "Why is this not part of the Landscape?",
                "aria-label": "Removal reason",
                "data-testid": Testids.landscapes.removeReasonInput
            }),
            /*#__PURE__*/ _jsx(SpecraButton, {
                type: "submit",
                size: "sm",
                disabled: !trimmed || pending,
                "data-testid": Testids.landscapes.removeConfirmButton,
                children: "Remove"
            }),
            /*#__PURE__*/ _jsx(SpecraButton, {
                type: "button",
                size: "sm",
                variant: "ghost",
                onClick: onCancel,
                children: "Cancel"
            })
        ]
    });
}
